package io.horion.cv.pages.cv

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaMoon
import com.varabyte.kobweb.silk.components.icons.fa.FaSun
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.api.datasource.common.Type
import io.horion.cv.components.HeaderBar
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.di.koinGet
import io.horion.cv.models.CvChoice
import io.horion.cv.models.CvData
import io.horion.cv.models.choices
import io.horion.cv.state.AppState
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import kotlinx.browser.window
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@OptIn(DelicateApi::class)
@Page("/modeles-cv/{model}")
@Composable
fun ModelCvPage() {

    val cvViewModel = koinGet<CvViewModel>()
    val cvUiState = cvViewModel.cvUiState
    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint <= Breakpoint.MD
    val isTablet = breakpoint == Breakpoint.LG

    var selectedChoice by remember { mutableStateOf(choices.first()) }
    val ctx = rememberPageContext()
    val  model = ctx.route.params["model"] ?: cvUiState.model
    val list = CvData.cvList[cvUiState.model.name]
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val pageBg    = if (isDark) Colors.DarkBG else Colors.White
    val textColor = if (isDark) Colors.White  else Colors.Primary

    Column(
        modifier = Modifier
            .fillMaxSize()
            .backgroundColor(pageBg)
            .styleModifier { property("transition", "background-color 300ms ease") }
    ) {
        Navbar(
            isMobile = isMobile,
            isTablet = isTablet,
//            icon = "/arrow-left-circle.svg",
//            text = "Modèles",
//            title = "Cv sans titre",
//            titleIcon = "/cloud-check.svg"
        )

        if (isMobile) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(
                        top = 25.px,
                        leftRight = 25.px,
                        bottom = 40.px
                    ),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SpanText(
                    "Choisissez\nVotre thème",
                    modifier = Modifier
                        .fontFamily(INTER)
                        .fontSize(24.px)
                        .fontWeight(FontWeight.SemiBold)
                        .color(textColor)
                        .whiteSpace(WhiteSpace.PreWrap)
                        .padding(bottom = 8.px)
                        .styleModifier { property("text-align", "center") }
                )

                SpanText(
                    "Choisissez une couleur principale\npour continuer",
                    modifier = Modifier
                        .fontFamily(INTER)
                        .fontSize(13.px)
                        .color(textColor)
                        .fontWeight(FontWeight.Light)
                        .whiteSpace(WhiteSpace.PreWrap)
                        .margin(bottom = 20.px)
                        .styleModifier { property("text-align", "center") }
                )

                CvImagePreview(
                    imgSrc = "/$list",
                    isMobile = true
                )

                Box(Modifier.height(24.px))

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(12.px, Alignment.CenterHorizontally)
                ) {
                    choices.forEach { choice ->
                        ChoiceButton(
                            choice = choice,
                            selected = choice.id == selectedChoice.id,
                            onClick = { selectedChoice = choice },
                            isMobile = true
                        )
                    }
                }

                Box(Modifier.height(24.px))
                ContinueButton()
            }
        } else {
            Row(
                modifier = Modifier
                    .fillMaxSize()
                    .backgroundColor(pageBg)
                    .padding(
                        top = 40.px,
                        right = 700.px,
                        left = 400.px
                        , bottom = 40.px
                    ),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.Top
            ) {
                Column(
                    modifier = Modifier
                        .width(420.px)
                ) {
                    SpanText(
                        "Choisissez\nVotre thème",
                        modifier = Modifier
                            .fontFamily(INTER)
                            .fontSize(40.px)
                            .fontWeight(FontWeight.SemiBold)
                            .color(textColor)
                            .whiteSpace(WhiteSpace.PreWrap)
                    )
                    Spacer()

                    SpanText(
                        "Choisissez une couleur principale\npour continuer",
                        modifier = Modifier
                            .fontFamily(INTER)
                            .fontSize(16.px)
                            .color(textColor)
                            .fontWeight(FontWeight.Light)
                            .whiteSpace(WhiteSpace.PreWrap)
                    )
                    Box(Modifier.height(30.px))

                    choices.forEach { choice ->
                        ChoiceButton(
                            choice = choice,
                            selected = choice.id == selectedChoice.id,
                            onClick = {
                                selectedChoice = choice
                                if (choice.id == "other"){
                                    cvViewModel.updateType(Type.OTHERS)
                                } else {
                                    cvViewModel.updateType(Type.PERSONNEL)
                                }
                            }
                        )
                        Box(Modifier.height(16.px))
                    }

                    Box(Modifier.height(30.px))

                    ContinueButton()
                }
                CvImagePreview(
                    imgSrc = "/$list"
                )
            }
        }
    }
}

@Composable
fun CvImagePreview(
    imgSrc: String,
    isMobile: Boolean = false,
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Box(
        modifier = Modifier
            .width(if (isMobile) 300.px else 330.px)
            .height(if (isMobile) 420.px else 460.px)
            .borderRadius(8.px)
            .styleModifier {
                property("overflow", "hidden")
                property(
                    "box-shadow",
                    if (isDark) "none" else "0px 2px 12px rgba(0,0,0,0.15)"
                )
                property("transition", "box-shadow 300ms ease")
            }
    ) {
        Image(
            src = imgSrc,
            description = "Aperçu du CV",
            modifier = Modifier.fillMaxSize()
                .styleModifier {
                    property("filter", if (isDark) "brightness(0.9)" else "none")
                }
        )
    }
}

@Composable
fun Navbar(
    isMobile: Boolean = false,
    isTablet: Boolean = false
) {
    var colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val navBg       = if (isDark) Colors.DarkBG   else Colors.White
    val borderColor = if (isDark) Colors.DarkGray else Colors.LightGray
    val textColor   = if (isDark) Colors.White     else Colors.Primary
    val iconFilter  = if (isDark) "none"           else "invert(1)"

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(navBg)
            .styleModifier { property("transition", "background-color 300ms ease") }
            .padding(when {
                isMobile -> 16.px
                isTablet -> 18.px
                else -> 20.px
            })
            .borderBottom(1.px, LineStyle.Solid, Colors.DarkGray),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Link(
            path = "/choose-cv",
            modifier = Modifier
                .textDecorationLine(TextDecorationLine.None)
                .onClick {
                    window.history.back()
                }
            ) {
            Row(
                modifier = Modifier
                    .cursor(Cursor.Pointer)
                    .margin(
                        left = when {
                            isMobile -> 10.px
                            isTablet -> 30.px
                            else -> 95.px
                        }
                    ),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Image(
                    src = "/arrow-left-circle.svg",
                    modifier = Modifier
                        .size(
                            when {
                                isMobile -> 18.px
                                isTablet -> 20.px
                                else -> 24.px
                            }
                        )
                        .styleModifier {
                            property("filter", iconFilter)
                        }
                )
                SpanText(
                    text = "Modèles",
                    modifier = Modifier
                        .margin(left = 10.px)
                        .fontFamily(INTER)
                        .fontSize(if (isMobile) 12.px else 16.px)
                        .color(textColor)
                )
            }
        }

        Spacer()

        Row(
            modifier = Modifier
                .margin(
                    right = when {
                        isMobile -> 30.px
                        isTablet -> 100.px
                        else -> 200.px
                    }
                ),
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                text = "Cv sans titre",
                modifier = Modifier
                    .margin(right = 10.px)
                    .fontFamily(INTER)
                    .fontSize(if (isMobile) 12.px else 16.px)
                    .fontWeight(FontWeight.Bold)
                    .color(textColor)
            )
            Image(
                src = "/cloud-check.svg",
                modifier = Modifier
                    .size(if (isMobile) 18.px else 24.px)
                    .styleModifier { property("filter", iconFilter) }
            )
        }

        Spacer()

        Row(
            modifier = Modifier.margin(right = if (isMobile) 10.px else 95.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (isDark) {
                FaSun(
                    modifier = Modifier
                        .fontSize(if (isMobile) 18.px else 25.px)
                        .color(Colors.yellow)
                        .cursor(Cursor.Pointer)
                        .onClick { colorMode = colorMode.opposite }
                )
            } else {
                FaMoon(
                    modifier = Modifier
                        .fontSize(if (isMobile) 18.px else 25.px)
                        .color(Colors.Primary)
                        .cursor(Cursor.Pointer)
                        .onClick { colorMode = colorMode.opposite }
                )
            }
        }
    }
}

@Composable
fun ChoiceButton(
    choice: CvChoice,
    selected: Boolean,
    onClick: () -> Unit,
    isMobile: Boolean = false
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val cardBg      = if (isDark) Colors.DarkBG  else Colors.White
    val labelColor  = if (isDark) Colors.White   else Colors.Primary
    val borderColor = if (selected) Colors.LightBlue  else
        if (isDark) Colors.Placeholder else Colors.LightGray

    Row(
        modifier = Modifier
            .width(if (isMobile) 160.px else 200.px)
            .height(if (isMobile) 56.px else 66.px)
            .padding(
                top = if (isMobile) 8.px else 11.px,
                bottom = if (isMobile) 8.px else 11.px,
                left = if (isMobile) 12.px else 17.px
            )
            .borderRadius(10.px)
            .backgroundColor(cardBg)
            .border(1.px, LineStyle.Solid, borderColor)
            .styleModifier { property("transition", "background-color 300ms ease") }
            .cursor(Cursor.Pointer)
            .onClick { onClick() },
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column {
            SpanText(
                choice.label,
                modifier = Modifier
                    .fontFamily(INTER)
                    .fontSize(if (isMobile) 14.px else 18.px)
                    .fontWeight(FontWeight.SemiBold)
                    .color(labelColor)
            )
            SpanText(
                choice.subtitle,
                modifier = Modifier
                    .fontFamily(INTER)
                    .fontSize(if (isMobile) 10.px else 12.px)
                    .fontWeight(FontWeight.Light)
                    .color(Colors.Placeholder)
            )
        }
    }
}

@Composable
fun ContinueButton() {

    val ctx = rememberPageContext()

    Button(
        onClick = {ctx.router.navigateTo("/info_pers")},
        modifier = Modifier
            .width(123.px)
            .height(42.px)
            .borderRadius(21.px)
            .backgroundColor(Colors.LighterBlue)
            .padding(topBottom = 10.px, leftRight = 20.px)
            .color(Colors.White)
            .fontSize(18.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.Normal)
            .styleModifier {
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
            }
    ) {
        SpanText("Continuer")
    }
}
